angular.module('zc.projects')

.directive 'zcReportGraph', ($filter, $translate, Report, Chart, currencies) ->
    restrict: 'E'
    scope:
      project : '='
      filters : '='
      isLatest: '='
    templateUrl: '/templates/projects.reports/report_graph.html'

    link: (scope, element, attrs) ->
      BILLING_RATE = 10
      MAX_SCALE_RATE = 1.1

      currency = currencies[scope.project.currency]

      Report.find
        apikey: scope.project.apikey
        dimension: 'daily'
      ,
        match:
          device: null
          target: null
          status: scope.filters.status
          begin_at: scope.filters.begin_at
        sort:
          start_at: 1
      .then (report_stats) ->
        scope.chartConfig = Chart.getChartConfig 'report'
        if scope.project.budget and scope.isLatest
          contributionPriceLimit = scope.project.budget * BILLING_RATE
          scope.chartConfig.options.yAxis.plotLines = [
            value: contributionPriceLimit
            color: 'red'
            dashStyle: 'shortdash'
            width: 2
            label:
              text: $translate.instant('projectsReports.directives.reportGraph.yosanjou_kiri_kingaku')
              y: 15
          ]
        scope.chartConfig.series = []

        Chart.addSeries scope.chartConfig,
          name: $translate.instant('projectsReports.directives.reportGraph.kakutoku_uriage')
          data: ([stats.start_at.valueOf(), stats.contribution_price] for stats in report_stats)
          tooltip:
            valuePrefix: currency.symbol
            valueSuffix: currency.suffix
            valueDecimals: currency.fractionSize



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.reports/report_graph.directive.coffee